/**
 * Query keys for the communications hub (F50), in a module of their own so the
 * notification hooks can refresh the inbox without importing its hooks (and
 * the inbox hooks can refresh the notifications without a cycle).
 */
import type { InboxView } from '@tonnie/types';

export const communicationsKeys = {
  inbox: ['inbox'] as const,
  inboxList: (view: InboxView) => [...communicationsKeys.inbox, 'list', view] as const,
  /** One message, as the reader shows it — whichever view it now sits in. */
  inboxItem: (id: string) => [...communicationsKeys.inbox, 'item', id] as const,
  /** The person's ONE unread number — the bell and the inbox page. */
  unreadCount: () => [...communicationsKeys.inbox, 'unreadCount'] as const,
  talent: (talentId: string) => ['talentCommunications', talentId] as const,
};
